import { render, staticRenderFns } from "./Aside.vue?vue&type=template&id=2bda68e2&scoped=true&"
import script from "./Aside.vue?vue&type=script&lang=js&"
export * from "./Aside.vue?vue&type=script&lang=js&"
import style0 from "./Aside.vue?vue&type=style&index=0&id=2bda68e2&scoped=true&lang=scss&"
import style1 from "./Aside.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bda68e2",
  null
  
)

export default component.exports